import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import TextInput from "components/Input/TextInput.js";
import { NotificationManager } from "react-notifications";
import {
  CustomSelect,
} from "components/Input/Index.js";
import Button from "@mui/material/Button";
import { makeStyles, withStyles } from "@mui/styles";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import AppBar from "@mui/material/AppBar";
import TabContext from "@mui/lab/TabContext";
import TabPanel from "@mui/lab/TabPanel";
import Divider from "@mui/material/Divider";
import ImageList from "@mui/material/ImageList";

import uuid from "react-uuid";
import sweetAlertStyle from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle";
import moment from "moment";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import UserService from "services/UserService";
import EmbeddedEntitesTree from "components/MenuEntites/EmbeddedEntitesTree";

import { postCEECampaignMembershipCase, putCEECampaignMembershipCase, getUsers } from "services/ConfigServices";
import styled from "styled-components";

import { ceecase as ceecasetxt } from "variables/cee";
import Dialog from "@mui/material/Dialog";
import MuiDialogContent from "@mui/material/DialogContent";
import MuiDialogActions from "@mui/material/DialogActions";
import CustomDialogTitle from "components/Dialog/CustomDialogTitle.js";
import { getCeecampaignMemberships } from "services/ConfigServices";
import CEECampaignsContext from "context/CEECampaignsContext";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import AutocompleteInputMeters from "components/Input/AutocompleteInputMeters.js";
import IntInput from "components/Input/IntInput";
import RTCaseFiles from "./CaseFiles/RTCaseFiles";

const DialogContent = withStyles((theme) => ({
  root: {
    padding: '16px',
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: '8px',
  },
}))(MuiDialogActions);

const StyledTabs = withStyles({
  indicator: {
    display: "flex",
    justifyContent: "center",
    backgroundColor: "transparent",
    "& > span": {
      maxWidth: 80,
      width: "100%",
      backgroundColor: "#91C73C",
    },
  },
})((props) => <Tabs {...props} TabIndicatorProps={{ children: <span /> }} />);

const StyledTab = withStyles((theme) => ({
  root: {
    textTransform: "none",
    color: "#000",
    fontWeight: 400,
    fontFamily: '"Source Sans Pro",sans-serif',
    fontSize: '0.9375rem',
    marginRight: '8px',
    minWidth: "auto",
    display: "flex",
    fullWidth: true,
    "&:focus": {
      opacity: 1,
    },
  },
}))((props) => <Tab disableRipple {...props} />);

const UseSweetAlertStyle = makeStyles(sweetAlertStyle);
const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: '16px',
      marginTop: "1rem",
      //width: "30ch",
    },
  },
  formControl: {
    margin: 8,
    width: "62ch",
  },
  gridList: {
    width: 330,
    height: 400,
    //marginLeft: "-2rem",
  },
  treeVisible: {
    display: "block",
  },
  treeHidden: {
    display: "none",
  },
  textField: {
    fontSize: "14px",
    fontFamily: '"Source Sans Pro",sans-serif',
    "& .MuiInputBase-input": {
      fontSize: "14px",
      fontFamily: '"Source Sans Pro",sans-serif',
    },
  },
  submitButton: {
    color: "#FFFFFF",
    backgroundColor: "#91C73C",
    fontWeight: "bold",
    display: "block",
    marginTop: "6px",
    marginRight: "auto",
    marginLeft: "25ch",
    width: "60ch",
    "&:hover": {
      backgroundColor: "#91C73C",
      boxShadow: "0px 11px 15px -7px rgb(0 0 0 / 20%)",
    },
  },
  submitButtonDisabled: {
    color: "#FFFFFF",
    backgroundColor: "#9798A0",
    fontWeight: "bold",
    display: "block",
    marginTop: "6px",
    marginRight: "auto",
    marginLeft: "25ch",
    width: "60ch",
  },
  padding: {
    padding: '0px',
  },
  demo2: {
    backgroundColor: "#fff",
    borderRadius: "5px",
  },
  demo3: {
    backgroundColor: "#fff",
    borderRadius: "5px",
  },
}));

const TreeLabel = styled.div`
  font-size: 14px;
  font-weight: 600;
  opacity: 1;
  font-family: "Source Sans Pro", sans-serif;
`;

const emailPattern = new RegExp(
  /^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/i
);

function CaseDialog(props) {
  const permis = JSON.parse(localStorage.getItem('permission')) || [];
  const ceeupdate = permis.includes("cee_update") ;
  const { closeModal, refetch, setLoading, currentCase } = props;
  console.log(currentCase);
  const advancedSearchContext = useContext(AdvancedSearchContext);
  const { chartIdGroup } = advancedSearchContext;
  const ceeCampaignContext = useContext(CEECampaignsContext);
  const { ceecampaign, setCeecampaign } = ceeCampaignContext;

  const [userlistdata, setUserlistdata] = useState([]);
  const [user, setUser] = useState({});
  const [inchargeuser, setInchargeuser] = useState(currentCase?.parameters?.inchargeuser || "")
  const [name, setName] = useState(currentCase?.parameters?.name || "");
  const [ceeform, setCeeform] = useState(currentCase?.parameters?.ceeform || "");
  const [kwhcumac, setKwhcumac] = useState(currentCase?.parameters?.kwhcumac || "");
  const [referentname, setReferentname] = useState(currentCase?.parameters?.referentname || "");
  const [referentemail, setReferentemail] = useState(currentCase?.parameters?.referentemail || "");
  const [referentphone, setReferentphone] = useState(currentCase?.parameters?.referentphone || "");
  const [description, setDescription] = useState(currentCase?.parameters?.description || "");
  const [comments, setComments] = useState(currentCase?.parameters?.comments || "");
  const [casefiles, setCasefiles] = useState(currentCase?.parameters?.casefiles || []);

  const [groups, setGroups] = useState(currentCase?.parameters?.groups ? "" + currentCase.parameters?.groups : "");
  const [groupsParent, setGroupsParent] = useState(
    ceecampaign?.parameters?.general?.groups?.[0]
  );
  const [buttonDisabled, setButtonDisabled] = useState(true);


  const handleNameChange = (event) => { setName(event.target.value); };
  const handleCeeformChange = (event) => { setCeeform(event.target.value); };
  const handleKwhcumacChange = (event) => { setKwhcumac(event.target.value); };
  const handleReferentnameChange = (event) => { setReferentname(event.target.value); };
  const handleReferentemailChange = (event) => { setReferentemail(event.target.value); };
  const handleReferentphoneChange = (event) => { setReferentphone(event.target.value); };
  const handleDescriptionChange = (event) => { setDescription(event.target.value); };
  const handleCommentsChange = (event) => { setComments(event.target.value); };

  const [membershipsOptions, setMembershipsOptions] = useState([]);
  const [memberships, setMemberships] = useState([]);
  const [membership, setMembership] = useState("");
  const [membershipname, setMembershipname] = useState("");
  const [membershipGroup, setMembershipGroup] = useState("");
  const selectedMembership = () => {
    let selected = {};
    console.log(membership);
    if (membership !== undefined) {
      selected = membership;
    }
    return selected;
  };
  const handleMembershipChange = (newValue) => {
    setMembership(newValue);
    if (newValue) {
      let obj = memberships.find((o) => o.id === newValue.id);
      setMembershipGroup(obj?.parameters.groups[0]);
    }
    else {
      setMembershipGroup("");
    }
  };
  useEffect(() => {
    axios
      .get(
        getCeecampaignMemberships(chartIdGroup, ceecampaign.id),
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
          },
        }
      )
      .then((res) => {
        let tmpMembershipsData = res.data.memberships?.map((data) => {
          return (
            { name: data.parameters.name, id: data.id }
          );
        });
        setMembershipsOptions(tmpMembershipsData || []);
        setMemberships(res.data.memberships || []);
        if (currentCase?.ceecampaignmembershipid) {
          let obj = tmpMembershipsData.find((o) => o.id === currentCase.ceecampaignmembershipid);
          console.log(obj);
          setMembership(obj);
          setMembershipname(obj.name);
        }
      });

  }, []);


  const selectedUser = () => {
    let selected = {};
    if (user !== undefined) {
      selected = user;
    }
    return selected;
  };
  const handleUserChange = (newValue) => {
    setUser(newValue);
    setInchargeuser(newValue.id);
    setReferentname(newValue.firstname + ' ' + newValue.lastname);
    setReferentemail(newValue.email);
    //setMeternumber(newValue.id);
  };
  useEffect(() => {
    axios
      .get(getUsers(chartIdGroup, 'users'), {
        headers: {
          Authorization: `Bearer ${UserService.getToken()}`,
        },
      })
      .then((res) => {
        var userlisttmp = [];
        userlisttmp = res.data.users.map((user) => {
          let newuser = { ...user };
          newuser.name = user.firstname + ' ' + user.lastname + ' (' + user.email + ')';
          return newuser;
        });
        setUserlistdata(userlisttmp || []);
        if (inchargeuser) {
          let usertmp = userlisttmp.find((o) => o.id === inchargeuser);
          setUser(usertmp);
        }
      });
  }, []);

  const classes = useStyles();
  const [value, setValue] = useState("0");

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleSubmit = (event) => {
    if (currentCase)
      updateCase(event);
    else
      createCase(event);
    //setLoading(true);
    closeModal();
  };

  useEffect(() => {
    if (!membership || !name || !groups || groups.length === 0)
      setButtonDisabled(true);
    else
      setButtonDisabled(false);
  });

  const createCase = async (event) => {
    axios
      .post(
        postCEECampaignMembershipCase(membership.id),
        {
          name,
          ceeform,
          kwhcumac,
          description,
          inchargeuser,
          referentname,
          referentemail,
          referentphone,
          comments,
          groups,
          casefiles,
          creationdate: (moment().unix()) * 1000,
          status: 'creation',
        },
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
            "Content-Type": "application/json; charset=utf-8",
          },
        }
      )
      .then((res) => {
        if (res.status == 200) {
          setNotification("success", "Dossier créé");
          refetch();
        } else setNotification("error", "Une erreur est survenue");
      })
      .catch((error) => {
        setNotification("error", "Une erreur est survenue");
        //setLoading(false);
      });
  };

  const updateCase = async (event) => {
    axios
      .put(
        putCEECampaignMembershipCase(currentCase.id),
        {
          ...currentCase.parameters,
          name,
          ceeform,
          kwhcumac,
          description,
          inchargeuser,
          referentname,
          referentemail,
          referentphone,
          comments,
          casefiles,
          groups,
        },
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
            "Content-Type": "application/json; charset=utf-8",
          },
        }
      )
      .then((res) => {
        if (res.status == 200) {
          setNotification("success", "Dossier modifié");
          refetch();
        } else setNotification("error", "Une erreur est survenue");
      })
      .catch((error) => {
        setNotification("error", "Une erreur est survenue");
        // setLoading(false);
      });
  };

  const setNotification = (status, text) => {
    if (status === "success") {
      NotificationManager.success(text);
    } else {
      NotificationManager.error(text);
    }
  };


  return (
    <>
      <TabContext value={value} className={classes.root}>
        <div className={classes.demo2}>
          <AppBar
            position="static"
            className={classes.demo3}
            style={{ boxShadow: "none", shadowColor: "red" }}
          >
            <StyledTabs
              value={value}
              onChange={handleChange}
              aria-label="styled tabs example"
              scrollButtons="auto"
            >
              <StyledTab label="Paramètres généraux" value="0" />
              <StyledTab label="Documents" value="1" />

            </StyledTabs>
            <Typography className={classes.padding} />
          </AppBar>
          <Divider variant="fullWidth" />
          <TabPanel value="0">
            <form className={classes.root}>
              <GridContainer>
                <GridItem xs={12} sm={6} md={7} lg={7}>
                  <div>
                    {
                      currentCase ?
                        <TextInput
                          inputTitle={"Membre"}
                          textInput={membershipname}
                          disabled={true}
                        />
                        :
                        <AutocompleteInputMeters
                          isRequired
                          specialWidth={"97%"}
                          inputTitle={"Choix du membre"}
                          selected={selectedMembership()}
                          list={membershipsOptions}
                          handleChange={(_, newValue) =>
                            handleMembershipChange(newValue)
                          }
                        />
                    }

                  </div>
                  <div>
                    <TextInput
                      inputTitle={ceecasetxt.name}
                      textInput={name}
                      handleTextInputChange={handleNameChange}
                      disabled={!ceeupdate}
                    />
                  </div>
                  <div>
                    <TextInput
                      inputTitle={ceecasetxt.ceeform}
                      textInput={ceeform}
                      handleTextInputChange={handleCeeformChange}
                      disabled={!ceeupdate}
                    />
                  </div>
                  <div>
                    <IntInput
                      inputTitle={ceecasetxt.kwhcumac}
                      intInput={kwhcumac}
                      handleIntInputChange={handleKwhcumacChange}
                      disabled={!ceeupdate}
                    />
                  </div>
                  {ceeupdate &&
                    <div>
                      <AutocompleteInputMeters
                        inputMargin={"1rem 0rem 0rem"}
                        specialWidth={"97%"}
                        inputTitle={ceecasetxt.inchargeuser}
                        selected={selectedUser()}
                        list={userlistdata}
                        handleChange={(_, newValue) =>
                          handleUserChange(newValue)
                        }
                      />
                    </div>
                  }
                  <div>
                    <TextInput
                      inputTitle={ceecasetxt.referentname}
                      textInput={referentname}
                      handleTextInputChange={handleReferentnameChange}
                      disabled={true}
                    />
                  </div>
                  <div>
                    <TextInput
                      inputTitle={ceecasetxt.referentemail}
                      textInput={referentemail}
                      handleTextInputChange={handleReferentemailChange}
                      disabled={true}
                    />
                  </div>
                  <div>
                    <TextInput
                      inputTitle={ceecasetxt.referentphone}
                      textInput={referentphone}
                      handleTextInputChange={handleReferentphoneChange}
                      disabled={!ceeupdate}
                    />
                  </div>
                  <div>
                    <TextInput
                      inputTitle={ceecasetxt.description}
                      textInput={description}
                      handleTextInputChange={handleDescriptionChange}
                      disabled={!ceeupdate}
                    />
                  </div>
                  <div>
                    <TextInput
                      inputTitle={ceecasetxt.comments}
                      textInput={comments}
                      handleTextInputChange={handleCommentsChange}
                      disabled={!ceeupdate}
                    />
                  </div>
                </GridItem>
                <GridItem xs={12} sm={6} md={5} lg={5}>
                  <div
                    className={classes.treeVisible}
                  >
                    <TreeLabel>Choix du périmètre</TreeLabel>
                    <ImageList rowHeight={140} className={classes.gridList} cols={1}>
                      <EmbeddedEntitesTree
                        selectedIds={setGroups}
                        userSelectedIds={groups}
                        filterfromnode={groupsParent}
                        disabled={!ceeupdate}
                      />
                    </ImageList>
                  </div>
                </GridItem>
              </GridContainer>
            </form>
          </TabPanel>
          <TabPanel value="1">
            <RTCaseFiles
              casefiles={casefiles}
              setCasefiles={setCasefiles}
              groups={groups}
            />
          </TabPanel>
        </div>
        <Button
          disabled={buttonDisabled}
          className={
            buttonDisabled
              ? classes.submitButtonDisabled
              : classes.submitButton
          }
          onClick={() => {
            handleSubmit();
          }}
        >
          Enregistrer
        </Button>
      </TabContext>
    </>
  );
}

export default CaseDialog;
